define('modules/lp_integration/views/webservice_popup',['require','exports','module','common/views/modal_layout','./fields_steps','ldsh!../templates/webservice_popup','./validation_popup'],function (require, exports, module) {
  'use strict';

  var ModalLayout = require('common/views/modal_layout'),
    StepsRegion = require('./fields_steps');

  module.exports = ModalLayout.extend({
    template: require('ldsh!../templates/webservice_popup'),
    className: 'ed-overlay popUp-integrate',
    regions: {
      steps: '#steps',
    },
    events: {
      'click .js-save': 'save',
      'click .js-cancel': 'hide',
    },
    /*helpers: function(){
      return {
        formFields: this.formFields.toJSON()
      };
    },*/
    initialize: function (options) {
      this.regions.steps.show(
        new StepsRegion({
          model: options.model,
          collection: options.formFields,
          defaultFields: options.defaultFields,
        })
      );
    },
    i18n: {
      validation: {
        url: 'integration.webserviceUrlError',
        fields: 'integration.webserviceFieldsError',
      },
    },
    save: function () {
      // get fields
      var url = this.$('#url').val().trim(),
        fieldAssociation = _.reduce(
          this.$('.js-fieldmapping'),
          function (result, item) {
            var pageField = $(item).data('field'),
              listField = $(item).find('input.js-postfield').val().trim();
            if (listField) {
              result[pageField.toString()] = listField;
            }
            return result;
          },
          {}
        );
      this.model.set('fields', fieldAssociation);
      this.model.set('url', url);
      if (this.model.isValid()) {
        this.model.set('active', true);
        this.model.save(null, { patch: true });
        this.hide();
      } else {
        this.model.set('active', false);
        if (this.model.isEmpty()) this.hide();
      }
    },
  });

  _.extend(module.exports.prototype, require('./validation_popup'));
});

